import React, { useState, useEffect, memo } from 'react';
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvent,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";

import { Icon } from "leaflet";
import MarkerIcon2X from "leaflet/dist/images/marker-icon-2x.png";
import MarkerIcon from "leaflet/dist/images/marker-icon.png";
import MarkerShadow from "leaflet/dist/images/marker-shadow.png";

Icon.Default.mergeOptions({
  iconRetinaUrl: MarkerIcon2X,
  iconUrl: MarkerIcon,
  shadowUrl: MarkerShadow,
});

function TestMapControl(latlng) {
  const map = useMap();
  if (latlng && latlng.latlng) {
    map.setView(latlng.latlng);
  }
  return null;
}

const SingleLocationMap = memo(({ lat = 52.520008, lng = 13.404954 }) => {

  const [latlng, setLatLng] = useState([lat, lng]); // default is center of berlin

  useEffect(() => {
    if (lat && lng) {
      setLatLng([lat, lng]);
    } else {
      setLatLng([52.520008, 13.404954]);
    }
  }, [lat, lng]);

  return (
    <div>
      <MapContainer
        center={latlng}
        zoom={12}
        scrollWheelZoom={false}
      >
        <TestMapControl latlng={latlng} />
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={latlng} />
      </MapContainer>
    </div>
  );
});

export default SingleLocationMap;
